import { Container, ContentMain, Info } from './Home.styled';

const HomePage = () => {
  return (
    <Container>
      <ContentMain>
        <Info>
          Welcome. There is a wide selection of cars for rent. Our fleet
          includes different models, from economy to premium. More than 8+ car
          classes.
        </Info>
      </ContentMain>
    </Container>
  );
};

export default HomePage;
